var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExcelFileIcon = function SvgExcelFileIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 48,
    viewBox: "0 0 37 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.5826 10.944C29.3855 10.9428 28.2379 10.4596 27.3914 9.60053C26.545 8.74145 26.069 7.57663 26.0678 6.36171V-0.000488281H5.89387C4.33124 -0.000488281 2.83261 0.629563 1.72766 1.75103C0.622708 2.8725 0.00195313 4.3935 0.00195312 5.97949V42.0284C0.00427363 43.6128 0.626053 45.1316 1.73075 46.2511C2.83545 47.3707 4.33275 47.9995 5.89387 47.9995H30.1096C30.8836 47.9998 31.65 47.8454 32.365 47.545C33.0801 47.2446 33.7299 46.8041 34.2773 46.2488C34.8246 45.6935 35.2588 45.0342 35.555 44.3085C35.8513 43.5828 36.0037 42.805 36.0037 42.0195V10.9351L30.5826 10.944Z",
    fill: "#54A575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0043 10.944H30.5831C29.3861 10.9428 28.2384 10.4596 27.392 9.60053C26.5456 8.74145 26.0695 7.57663 26.0684 6.36171V-0.000488281L36.0043 10.944Z",
    fill: "#54A575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 33.5112H9.97127C8.58095 33.5112 7.45117 32.1068 7.45117 30.3779V18.5579C7.45117 16.8312 8.58095 15.4268 9.97127 15.4268H26.0312C27.4215 15.4268 28.5513 16.8312 28.5513 18.5579V30.3779C28.5513 32.1068 27.4215 33.5112 26.0312 33.5112ZM9.97127 17.0268C9.29253 17.0268 8.73859 17.7134 8.73859 18.5579V30.3779C8.73859 31.2223 9.29253 31.909 9.97127 31.909H26.0312C26.7099 31.909 27.2617 31.2223 27.2617 30.3779V18.5579C27.2617 17.7134 26.7099 17.0268 26.0312 17.0268H9.97127Z",
    fill: "#54A575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9084 26.3931H8.0957V27.9953H27.9084V26.3931Z",
    fill: "#54A575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9084 20.9004H8.0957V22.5026H27.9084V20.9004Z",
    fill: "#54A575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8364 16.2266H21.2578V32.7088H22.8364V16.2266Z",
    fill: "#54A575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7485 16.2266H13.1699V32.7088H14.7485V16.2266Z",
    fill: "#54A575"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExcelFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/excel-file-icon.d9f3cff5839ac4cd4e3d3d518a814495.svg";